import { render, staticRenderFns } from "./NewChart.vue?vue&type=template&id=b68a3408"
import script from "./NewChart.vue?vue&type=script&lang=js"
export * from "./NewChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports